import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  StockOptions = 'StockOptions',
  EquityCompensationPdf = 'EquityCompensationPdf',
  Print = 'Print',
}

export const queryKeys = {
  stockOptions: (clientId: string) => [QueryFeature.Profile, QueryKey.StockOptions, clientId],
  stockOptionsPrint: (clientId: number, fpId: string) => [
    QueryFeature.Profile,
    QueryKey.EquityCompensationPdf,
    QueryKey.Print,
    clientId,
    fpId,
  ],
};
